import { CREATE_PATHS } from '../../../helpers/api/apiPaths';
import { post } from '../../../helpers/api/post';

const API_CREATE = 'API_CREATE';
const replacer = (tpl, data) => tpl.replace(/{([^)]+)?}/g, ($1, $2) => data[$2]);

const loadData = (store, next, resourceAction, resource) => {
  next({ type: `${resourceAction}_LOADING`, resource });

  return post(`${replacer(CREATE_PATHS[resourceAction], resource)}`, resource)
    .then(
      response => store.dispatch({ type: `${resourceAction}_SUCCESS`, replaceId: resource.id, response }),
      () => store.dispatch({ type: `${resourceAction}_FAILED`, resource }),
    );
};

export default store => next =>
  action =>
    ((action.resourceAction && action.resourceAction.startsWith(API_CREATE) && action.resource)
      ? loadData(store, next, action.resourceAction, action.resource)
      : next(action));



// WEBPACK FOOTER //
// ./src/reducers/middleware/resourceCreator/resourceCreator.middleware.js